import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import Typography from '@/components/UI/typography/Typography';
import { useMidTermQuery } from '@/components/houses/_hooks/useMidterm';
import styles from './MidtermTehranInfo.module.scss';
const MidtermTehranInfo = ({
  props
}) => {
  const {
    isMidTerm,
    toggleMidTerm
  } = useMidTermQuery(props);
  const handleMidtermChange = () => {
    toggleMidTerm();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      {isMidTerm ? <Box className={styles['short-term-wrapper']} component={'section'}>
          <Typography className={styles['short-term-content']} variant="bodyM" color="neutral_800">
            قصد رزرو کوتاه‌مدت این اقامتگاه را دارید؟
          </Typography>
          <Button className={styles['short-term-button']} onClick={handleMidtermChange} format="primary">
            ثبت رزرو
          </Button>
        </Box> : <Box className={styles['mid-term-wrapper']} component={'section'}>
          <Box className={styles['mid-term-content']}>
            <Typography variant="bodyM" color="tertiary_600">
              {props?.pricing?.records?.[0].monthly_discount}%
            </Typography>
            <Typography variant="bodyM" color="tertiary_600">
              {` تخفیف ویژه رزروهای ماهانه تهران `}{' '}
            </Typography>
          </Box>
          <Button onClick={handleMidtermChange} className={styles['mid-term-button']} format="primary">
            ثبت رزرو
          </Button>
        </Box>}
    </>;
};
export default MidtermTehranInfo;